// extracted by mini-css-extract-plugin
export default {"PageTemplate":"PageTemplate_PageTemplate__OP4+t","temp":"PageTemplate_temp__z9eS3"};